//#region Components
import SimpleTableList from "../SimpleTableList/SimpleTableList";
import StudentTableListItem from "../StudentTableListItem/StudentTableListItem";
import StudentTableListResponsableItem from "../StudentTableListItem/StudentTableListResponsableItem";
//#endregion
//#region Utils
import { HEADER_TABLE_LIST } from "../utils/constants";
//#endregion

const StudentTableList = ({
    data,
    selectedStudents,
    getInfoTooltipOfPenalize,
    formList
}) => {
    return (
        <SimpleTableList
            headers={HEADER_TABLE_LIST}
            maxHeight="25vh"
            content={
                <>
                    <StudentTableListResponsableItem selectedStudents={selectedStudents} />
                    {data.map((item, idx) => (
                        <StudentTableListItem
                            key={idx}
                            item={item}
                            isResponsible={idx === 0}
                            selectedStudents={selectedStudents}
                            getInfoTooltipOfPenalize={getInfoTooltipOfPenalize}
                            formList={formList} />
                    ))}
                </>
            } />
    );
}

export default StudentTableList